import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { DescontoService } from '../desconto.service';
import { GrupoDesconto } from '../models/desconto';

@Component({
  selector: 'app-grupo-desconto',
  templateUrl: './grupo-desconto.component.html',
  styleUrls: ['./grupo-desconto.component.scss']
})
export class GrupoDescontoComponent implements OnInit {

  constructor(private descontoService : DescontoService, private router: Router, private route: ActivatedRoute, private activateRoute: ActivatedRoute) { }

  public listaGruposDesconto: GrupoDesconto[];
  
  ngOnInit(): void {
     this.getGrupos();    
  }

  getGrupos(){
    this.descontoService.getGruposDesconto().subscribe(
      (res) => {
        if (res) {            
          this.listaGruposDesconto = res; 
        }
      },
      err => {
        console.log("ERRO GD-LIST");
        console.log(err);
      }
    );
  }

}
